import { lighten, makeStyles } from "@material-ui/core";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const EmailStyle = makeStyles((theme) => ({
    root: {
        paddingBottom: "2rem",
        borderBottom: "3px solid #000",
        "& > p": {
            margin: "0.5rem 0",
        },
    },
    bqsEditRow: {
        display: "flex",
        [breakpointTheme.breakpoints.up("sm")]: {
            "& > div": {
                "& > div": {
                    maxWidth: "300px",
                },
            },
        },
    },
    bqsButton: {
        margin: "1rem 0.75rem !important",
    },
}));
